import React, {Fragment} from 'react'
import styles from './PrivateUserPage.scss'
import {Card} from 'common/styleguide/Card'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import fetchJSON from 'lib/fetchJSON'
import {ProfileImg} from 'common/ProfileImg'
import {deserializeUser} from 'lib/api/records'
import {FriendInteractionsButtons} from 'common/FriendInteractionsButtons'
import {browserHistory} from 'react-router'
import {ConfirmRemoveFriend, CONFIRM_REMOVE_FRIEND_DIALOG} from 'common/dialogs/ConfirmRemoveFriend'

const PrivateUserPage = ({top, middle, buttons}) => {
  return (
    <div className={styles.privatePage}>
      <Card className={styles.card}>
        {top}
        {middle}
        <div className={styles.buttons}>
          {buttons}
        </div>
      </Card>
    </div>
  )
}

export class PrivateUserProfilePage extends React.PureComponent {
  submitClicked = (e) => {
    if (window.zE) {
      e.preventDefault()
      window.zE('webWidget', 'show')
      window.zE('webWidget', 'open')
    }
  }

  render () {
    return (
      <PrivateUserPage
        top={<div className={styles.icon}>
          <Icon i='404' size={84} />
        </div>}
        middle={<Fragment>
          <h2>The page you are looking for does not exist.</h2>
          <p style={{marginBottom: '20px'}}>If you expect something to be here, please submit a Support ticket. Thanks!</p>
        </Fragment>}
        buttons={<Fragment>
          <CTA inline margins={false} onClick={this.submitClicked} href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>Submit a Support Ticket</CTA>
          <CTA inline margins={false} link onClick={() => browserHistory.goBack()}>Go Back</CTA>
        </Fragment>}
      />
    )
  }
}

export class FriendsOnlyUserProfilePage extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      user: null,
      userLoaded: false,
      modal: null
    }
  }

  componentDidMount () {
    const {userId} = this.props

    fetchJSON(`/users/${userId}/private_user_show.json`).then(({user}) => {
      this.setState({user: deserializeUser(user), userLoaded: true})
    })
  }

  showDialog = (dialog) => {
    this.setState({modal: dialog})
  }

  clearDialog = () => {
    this.setState({modal: null})
  }

  render () {
    const {user, userLoaded, modal} = this.state
    const {userIsFriend} = this.props

    const body = userIsFriend
      ? <div>
      You are friends with {user ? user.name : 'this user'}, but their profile is currently <em>Private</em>.
      If {user ? user.name : 'this user'} changes their profile privacy setting, their profile will become visible.
      </div>
      : <div>
      The profile you are trying to view is set to <em>Friends Only</em>.
      Please request to add them as a friend to view their profile.
      </div>

    return (
      <Fragment>
        {modal === CONFIRM_REMOVE_FRIEND_DIALOG && <ConfirmRemoveFriend toUnfriend={user} onRequestClose={this.clearDialog} />}
        <PrivateUserPage
          top={<div className={styles.icon}>
            <ProfileImg large user={user} />
          </div>}
          middle={<Fragment>
            <h2>{user && user.name}</h2>
            {body}
          </Fragment>}
          buttons={userLoaded && <FriendInteractionsButtons
            user={user}
            privateUser
            userIsFriend={userIsFriend}
            showDialog={this.showDialog} />} />
      </Fragment>
    )
  }
}
